import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { BroadcastChannelTypeEnum } from 'app/models';
import { AuthService, OperatorService } from 'app/services';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'one-time-password',
  templateUrl: './one-time-password.component.html',
  styleUrls: [
    './one-time-password.component.scss',
    '../operator-login/operator-login.component.scss',
  ],
})
export class OneTimePasswordComponent implements OnInit, OnDestroy {
  otpValue = '';

  isLoadingOverlay = false;
  otpError: string | null = null;
  otpInputError = false;

  @Input() public ProcessId!: string;
  @Output() public verifiedOtp = new EventEmitter<string>(); // ProcessId

  secondsOtpBlock: number = 0;
  otpBlockInterval: any;
  wrongOtpAttemptCount: number = 0;
  secondsToResend: number = 180;
  sendOTPProcessId: string = '';
  resendInterval: any;

  buildNumber: string | null = '';
  apiBaseUrl: string | null = '';
  apiVersion: string | null = '';
  apiUrl: string | null = '';

  constructor(
    private authService: AuthService,
    private messageService: MessageService,
    private operatorService: OperatorService
  ) {}

  ngOnInit(): void {
    this.buildNumber = sessionStorage.getItem('BuildNumber');
    this.apiBaseUrl = sessionStorage.getItem('API_BaseUrl');
    this.apiVersion = sessionStorage.getItem('API_Version');
    this.setResendTimer();
  }

  ngOnDestroy(): void {
    clearInterval(this.resendInterval);
    clearInterval(this.otpBlockInterval);
  }

  setWrongOtpError() {
    if (this.secondsOtpBlock === 0) {
      this.secondsOtpBlock = 300;
      this.setOtpBlockTimer();
    }
  }

  //Call api CheckOneTimePassword for mark OTP as verified
  checkOneTimePassword(processId: string, password: string) {
    this.apiUrl = this.apiBaseUrl + '' + this.apiVersion;
    const checkOtpApiUrl = this.apiUrl + 'api/Otp/CheckOTP';

    this.showLoadingOverlay();
    this.authService
      .checkOneTimePassword(checkOtpApiUrl, processId, password)
      .then((response) => response.json())
      .then((checkOtpResponse) => {
        this.hideLoadingOverlay();
        if (checkOtpResponse.ErrorMessage) {
          if (
            checkOtpResponse.ErrorMessage.includes('Wrong One-Time password')
          ) {
            this.otpError = 'Invalid OTP. Please try again.';
            this.otpValue = '';
          } else {
            this.otpError = checkOtpResponse.ErrorMessage;
          }

          this.otpInputError = true;

          this.wrongOtpAttemptCount += 1;
          if (this.wrongOtpAttemptCount === 3) {
            this.setWrongOtpError();
          }
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: checkOtpResponse.ErrorMessage,
          });
          return;
        }

        this.otpInputError = false;
        this.otpError = null;

        this.verifiedOtp.emit(processId);
      });
  }

  showLoadingOverlay() {
    this.isLoadingOverlay = true;
  }

  hideLoadingOverlay() {
    this.isLoadingOverlay = false;
  }

  setResendTimer() {
    clearInterval(this.resendInterval);
    this.resendInterval = setInterval(() => {
      if (this.secondsToResend > 0) {
        this.secondsToResend -= 1;
      }
    }, 1000);
  }

  setOtpBlockTimer() {
    clearInterval(this.otpBlockInterval);
    this.otpBlockInterval = setInterval(() => {
      if (this.secondsOtpBlock > 0) {
        this.secondsOtpBlock -= 1;
      } else if (this.secondsOtpBlock === 0) {
        this.wrongOtpAttemptCount = 0;
        clearInterval(this.otpBlockInterval);
      }
    }, 1000);
  }

  resendOTP() {
    if (this.secondsToResend > 0) {
      return;
    }

    const dto = {
      ProcessId: this.ProcessId,
      BroadcastChannelType: BroadcastChannelTypeEnum.Email,
    };

    this.showLoadingOverlay();
    this.operatorService
      .resendOperatorOTP(dto, this.messageService)
      .then((data) => {
        if (!data.Success) {
          this.otpError = data.ErrorMessage;
          this.hideLoadingOverlay();
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: data.ErrorMessage,
          });
          return;
        }
        this.ProcessId = data.ProcessId;
        this.secondsToResend = 180;
        this.sendOTPProcessId = data.ProcessId;
        this.otpError = null;
        this.otpInputError = false;
        this.setResendTimer();
        this.hideLoadingOverlay();
      })
      .catch((err) => {
        this.hideLoadingOverlay();
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: err,
        });
      });
  }
}
